/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
const APP_ID = process.env.VUE_APP_INTERCOM_APP_ID;

const intercomeWidgetInit = () =>
  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/vex4omco'
  {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function() {
        i.c(arguments);
      };
      i.q = [];
      i.c = function(args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function() {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${APP_ID}`;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  };

const visitors = () => {
  window.intercomSettings = {
    app_id: APP_ID
  };
};

const loggedinUsers = ({ userName, userEmail, userId }) => {
  window.intercomSettings = {
    app_id: APP_ID,
    name: userName, // Full name
    email: userEmail, // Email address
    user_id: userId // User Id
    // created_at: '<%= current_user.created_at.to_i %>' // Signup date as a Unix timestamp
  };
};

export { visitors, loggedinUsers, intercomeWidgetInit };
